<div class="terms-settings-card">
  @if(isLoading()) {
    <div class="loading-container">
      <app-loading-animation></app-loading-animation>
      <p>Loading terms content...</p>
    </div>
  } @else {
    <!-- Toggle Section -->
    <div class="toggle-section">
      <div class="toggle-row">
        <label class="toggle-label" for="termsToggle">Terms and Conditions</label>
        <span class="switch">
          <input
            id="termsToggle"
            type="checkbox"
            [checked]="isTermsEnabled()"
            [disabled]="isUpdatingStatus()"
            (change)="toggleTermsEnabled()"
          />
          <span class="slider round"></span>
        </span>
      </div>
      
      @if(!isTermsEnabled()) {
        <div class="warning-message">
          Terms and conditions are currently disabled. Users will not be required to accept terms when logging in.
        </div>
      }
      
      @if(statusMessage()) {
        <div class="status-message" [class.error]="statusMessage().includes('Error')">
          {{ statusMessage() }}
        </div>
      }
    </div>

    <!-- Content Section -->
    <div class="content-section">
      <label for="termsContent" class="content-label">
        <span class="label-text">Terms and Conditions Content</span>
        @if(!isTermsEnabled()) {
          <span class="disabled-hint">(Enable to edit)</span>
        }
      </label>
      
      <textarea 
        id="termsContent"
        class="terms-textarea"
        [(ngModel)]="termsContent"
        (input)="onTermsContentChange()"
        [disabled]="!isTermsEnabled()"
        placeholder="Terms and Conditions"
        rows="10">
      </textarea>
      
      <div class="help-text">
        <div><strong>Supported HTML:</strong> h1-h6, p, div, span, strong, em, ul, ol, li, a, br</div>
        <div><strong>Security:</strong> Scripts, iframes, and event handlers are automatically removed</div>
      </div>

      @if(securityWarning()) {
        <div class="security-warning">
          {{ securityWarning() }}
        </div>
      }
    </div>

    <!-- Actions -->
    <div class="actions-section">
      <button 
        type="button" 
        class="btn-secondary"
        [disabled]="!hasUnsavedChanges() || isSaving() || !isTermsEnabled()"
        (click)="discardChanges()">
        Discard Changes
      </button>
      <button 
        type="button" 
        class="btn-primary"
        [disabled]="isSaving() || !isTermsEnabled()"
        (click)="saveTermsContent()">
        @if (!isSaving()) {
        <span>Save Terms</span>
        } @else {
        <span>Saving...</span>
        }
      </button>
    </div>

    @if(saveMessage()) {
      <div class="save-message" [class.success]="!saveMessage().includes('Error')" [class.error]="saveMessage().includes('Error')">
        {{ saveMessage() }}
      </div>
    }
  }
</div>
